import React, { ReactNode } from 'react'

export default function InfoContent({ className, children }: { className?: string; children: ReactNode }) {
  return <span className={`text-gray-21 mt-[5px] block font-bold ${className}`}>{children}</span>
}
